import React from "react";
import { useSelector } from "react-redux";
import { selectIsCms } from "../../../../redux/slices/configSettingsSlice";
import RecurringSummaryCancelContent from "./RecurringSummaryCancelContent";

/**
 * @param {object} props
 * @param {object} props.control
 * @param {Function} props.setDisplayModal
 * @returns {React.JSX.Element}
 */
const ConnectedRecurringSummaryCancelContent = ({
    control,
    setDisplayModal,
}) => {
    const isCms = useSelector(selectIsCms);

    const { options = {} } = control;
    const {
        cancelButtonLabel = "Cancel Ongoing Gift",
        heading = "Need to Cancel?",
    } = options;

    const recurringSummaryCancelContentProps = {
        cancelButtonLabel,
        heading,
        isCms,
        setDisplayModal,
    };
    return (
        <RecurringSummaryCancelContent
            {...recurringSummaryCancelContentProps}
        />
    );
};

export default ConnectedRecurringSummaryCancelContent;
